import { defineMessages } from 'react-intl';

export default defineMessages({
  label: {
    id: 'app.components.Autocomplete.label',
    defaultMessage: 'Qual o nome do condomínio?',
  },
  iDoNotKnowTheName: {
    id: 'app.components.Autocomplete.iDoNotKnowTheName',
    defaultMessage: 'Não sei o nome',
  },
  placeholder: {
    id: 'app.components.Autocomplete.placeholder',
    defaultMessage: 'Digite o nome do condomínio',
  },
  invalidName: {
    id: 'app.components.Autocomplete.invalidNames',
    defaultMessage: 'Nome inválido',
  },
});
